import classNames from 'classnames';
import { BodyText, Heading1, Heading2 } from '@sb1/ffe-core-react';
import styles from './anniversary-page.module.less';
import { CUSTOM_COMPONENTS, getContentIdForComponent } from '../../utils/cms-utils';
import Image from '../image/Image';
import Carousel from './Carousel';
import ScreenReaderOnly from '../../accessibility/ScreenReaderOnly';

const groupArticleCardsByYear = (content) => {
    const articleCards = (content || []).filter(
        (entry) => getContentIdForComponent(entry) === CUSTOM_COMPONENTS.ARTICLE_CARD
    );

    const groupsByYear = articleCards.reduce((groups, articleCard) => {
        const year = articleCard.fields?.subText?.trim() || '';
        const existingGroup = groups.get(year);

        if (existingGroup) {
            existingGroup.cards.push(articleCard);
            return groups;
        }

        groups.set(year, { year, cards: [articleCard] });
        return groups;
    }, new Map());

    return Array.from(groupsByYear.values()).sort((a, b) => Number(b.year) - Number(a.year));
};

const AnniversaryPage = ({ content, articleCards }) => {
    const { headerSection = [] } = content || {};
    const highlightsByYear = groupArticleCardsByYear(articleCards);

    return (
        <div className={styles.anniversaryPage}>
            <div className={styles.headerImageContainer}>
                <Image
                    className={styles.headerBackground}
                    src="10-year-anniversary/10-year-header-background.svg"
                    alt=""
                    loading="eager"
                />
                <Image
                    className={styles.headerText}
                    src="10-year-anniversary/10-year-text.svg"
                    alt=""
                    loading="eager"
                />
                <ScreenReaderOnly>
                    <Heading1>10 år med spleiseglede</Heading1>
                </ScreenReaderOnly>
            </div>
            <div className={styles.pageContent}>
                <div className={styles.textCardsContainer}>
                    {headerSection.map((textCard, index) => {
                        const hasImage = Boolean(textCard.imgUrl);

                        return (
                            <div
                                key={`stat-item-${index}`}
                                className={classNames(styles.textCard, hasImage && styles.textCardWithImage)}
                                style={{ backgroundColor: textCard.backgroundColor }}
                            >
                                {hasImage && (
                                    <div className={styles.textCardImageWrapper}>
                                        <Image
                                            className={styles.textCardImage}
                                            src={textCard.imgUrl}
                                            alt={textCard.title}
                                        />
                                    </div>
                                )}
                                <div className={[styles.textCardContent, 'ffe-accent-mode'].join(' ')}>
                                    <Heading2 noMargin>{textCard.title}</Heading2>
                                    <BodyText>{textCard.description}</BodyText>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {highlightsByYear.length > 0 && (
                    <section className={styles.highlightsSection}>
                        {highlightsByYear.map(({ year, cards }) => (
                            <div key={year || 'highlights'} className={styles.yearGroup}>
                                {year && <Heading2 className={styles.yearTitle}>{year}</Heading2>}
                                <Carousel cards={cards} />
                            </div>
                        ))}
                    </section>
                )}
            </div>
        </div>
    );
};

export default AnniversaryPage;
